import colors from './colors';

const palette = {
  common: {
    white: colors.white,
  },
  primary: {
    main: colors.blueberry,
  },
  secondary: {
    main: colors.lightBlue,
  },
  error: {
    main: colors.tomatoRed,
  },
  warning: {
    main: colors.navy,
  },
  success: {
    main: colors.blueberry,
  },
  info: {
    main: colors.blueberry,
  },
} as const;

export default palette;
